import { service } from '@/utils/request'

export default {

    // 查询
    getList(data) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/pages`,
            method: 'post',
            data
        })
    },
    // 新增
    add(data) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/insert`,
            method: 'post',
            data
        })
    },
    // 新增
    edit(data) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/update`,
            method: 'put',
            data
        })
    },
    // 上下架
    changeState(params) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/changeState`,
            method: 'put',
            params
        })
    },
    // 详情
    getDetail(params) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/details`,
            method: 'get',
            params
        })
    },
    // 报名表
    getUserList(data) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/userPages`,
            method: 'post',
            data
        })
    },
    // 单个短信
    sendRemindSingle(id) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/sendRemind?id=${id}`,
            method: 'post'
        })
    },
    // 批量短信
    sendRemindAll(data) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/batchSendRemind`,
            method: 'post',
            data
        })
    },
    // 报名用户导出
    exportUser(params) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/exportExcel`,
            method: 'get',
            params,
            responseType: 'blob'
        })
    },
    getActiveData(params) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/data/list`,
            method: 'get',
            params,
        })
    },
    exportDataExcel(params) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/exportDataExcel`,
            method: 'get',
            params,
            responseType: 'blob'
        })
    },
    getDataUserPage(params) {
        return service({
            url: `/cloud/order/admin/superGroupBuy/data/userPages`,
            method: 'get',
            params,
        })
    },

}



// WEBPACK FOOTER //
// ./src/api/operateManage/superGroup.js